import { createStore } from 'vuex';

// Global
import framework from '@/modules/framework/storeDeprecated';

// Modules

import activityFeed from '@/modules/activity-feed/store';
import actionCentre from '@/modules/action-centre/store';
import uploads from '@/modules/uploads/store';
import emergingThreats from '@/modules/emerging-threats-common/store';
import assessment from '@/modules/assessment/store';
import discussions from '@/modules/discussions/store';
import invite from '@/modules/invite/store';
import risks from '@/modules/risks/store';
import { zeusStoreModules } from '@/zeusIntegration';

import legacy from '@/legacy/store';

import type { State } from './useStore';

const store = createStore<State>({
  modules: {
    // oxlint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    legacy,
    framework,
    actionCentre,
    assessment,
    discussions,
    invite,
    activityFeed,
    uploads,
    risks,
    emergingThreats,
    ...zeusStoreModules,
  },
  strict: import.meta.env.MODE !== 'prod',
});

export default store;
